<template>
  <div>
    <div class="row row-0 row-reverse">
      <div class="col-sm-6">
        <div
          v-if="thumbnail"
          class="thumbnail-play"
          data-trackingclass="landing-page-clic-bouton"
          data-trackinginfo="landing-page-CAPS-up2payfid-video"
          @click.prevent="thumbnail = false"
        >
          <img
            src="../assets/images/play.png"
            data-trackingclass="landing-page-clic-bouton"
            data-trackinginfo="landing-page-CAPS-up2payfid-video"
            @click.prevent="thumbnail = false"
          />
        </div>

        <iframe
          v-else
          width="560"
          height="315"
          src="https://www.youtube.com/embed/pPA8eeXqQbo?autoplay=1"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        >
        </iframe>
      </div>
      <div class="col-sm-6">
        <img src="../assets/images/last-sec-bg.jpg" alt="" class="img-fluid" />
        <div id="ca5s4-content-box">
          <p id="green-text">Pour aller plus loin</p>
          <p id="cyan-text">
            Développez votre activité
            <br />avec Up2pay Fidélité !
          </p>
          <p id="regular-text">
            Augmentez la fréquence de visite de vos clients grâce au programme de fidélité
            personnalisé du Crédit Agricole. Intégré à votre TPE, il transforme la carte de
            paiement de vos clients en carte de fidélité et facilite la gestion de la relation client !
          </p>
          <p>
            <a href="https://www.credit-agricole.fr/professionnel/campagnes/fideliser-sa-clientele.html" target="_top">
              En savoir plus
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      thumbnail: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .thumbnail-play {
    background: url(../assets/images/video.jpg) no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;

    img {
      position: absolute;
      top: calc(50% - 50px);
      left: calc(50% - 50px);
      width: 100px;
      z-index: 5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Video.vue